import { Component, OnInit } from '@angular/core';
import {HttpService} from '../../../services/http.service';
import {Filter} from '../../../models/warranties/filter.model';
import {BlacklistList} from '../../../models/blacklist/blacklist-list.model';
import {BlacklistVin} from '../../../models/blacklist/blacklist-vin.model';
import {SweetUtil} from '../../commons/sweet/sweet-util-service';

@Component({
  selector: 'app-blacklist',
  templateUrl: './blacklist.component.html',
  styleUrls: ['./blacklist.component.css']
})
export class BlacklistComponent implements OnInit {

  vinList: BlacklistList;
  filter: Filter = new Filter();
  vin: string;

  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.fetchBlacklistedVins();
  }

  search() {
    this.fetchBlacklistedVins();
  }

  fetchBlacklistedVins() {
    this.http.fetchBlacklistedVins(this.filter).subscribe((vins) => {
      this.vinList = Object.assign(new BlacklistList(), vins);
    });
  }

  addBlacklistVin() {
    if (this.vin.length == 17) {
      let v = new BlacklistVin();
      v.vin = this.vin;
      v.id = null;
      this.http.addBlacklistVin(v).subscribe(() => {
        this.fetchBlacklistedVins();
      });
    } else {
      alert('Invalid Vin');
    }
  }

  deleteBlacklistedVin(vin: BlacklistVin) {
    SweetUtil.getConfirm('Remove VIN','Are you sure you want to allow this VIN ' + vin + ' to be processed for Warranties?').then((res)=>{
      if (res.value) {
        this.http.deleteBlacklistedVin(vin.id).subscribe(() => {
          this.fetchBlacklistedVins();
        });
      }
    });
  }

  orderBy(field: string) {
    if (this.filter.orderBy == field) {
      if (this.filter.order == 'ASC')
        this.filter.order = 'DESC';
      else this.filter.order = 'ASC';
    }
    this.filter.orderBy = field;
    this.fetchBlacklistedVins();
  }

  showDirectionImage() : string {
    if (this.filter.order == 'ASC') return 'assets/images/icon-sort-up.png';
    else return 'assets/images/icon-sort-down.png';
  }

  changePage(count: number) {
    this.filter.page += count;
    this.fetchBlacklistedVins();
  }

  clear() {
    this.filter = new Filter();
    this.fetchBlacklistedVins();
  }
}
